/***********************************************
* SideBar.js
* 
* Show the project list
***********************************************/
/* Layout files */
import '../assets/style/SideBar.css'

/* Global imports */
import React   from 'react';
import { clsx } from 'clsx';

/* Local imports */
import API              from './API';
import NewOpenProject   from './NewOpenProject';
//import { ConfirmPopup, HelpPopup } from "./Popup";
import { ConfirmPopup } from "./Popup";

//import newProjGif  from "../assets/images/NewProject.gif";

export default class SideBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            projectId: 0,           // Selected project ID
            projectList: [],        // The list of projects
            folderList: [],         // The list of folders
            folderOpen: [],         // The list of open folders
            deleteProject: -1,      // Project ID to delete
            deleteTitle: "",        // Project name to delete
            expandSidebar: false,   // Show or hide sidebar
        };

        this.handleProjectsLoaded = this.handleProjectsLoaded.bind(this);
        this.handleProjectRemoved = this.handleProjectRemoved.bind(this);
        this.handleCreatedNew     = this.handleCreatedNew.bind(this);
        this.renderProject        = this.renderProject.bind(this);
    }

    /* Poll the project list every 10 seconds */
    componentDidMount() {
        API.GetFolders((json) => {
            var folderList = [];
            json.forEach((json) => {
                folderList[json.id] = json;
            });
            this.setState({folderList: folderList})
        })
        API.GetProject(-1, this.handleProjectsLoaded);
        this.apiTimer = setInterval(() => API.GetProject(-1, this.handleProjectsLoaded), 10000);
    }
    componentWillUnmount() { clearInterval(this.apiTimer); }
    
    /* Parse project list from reply */
    handleProjectsLoaded(reply) {
        var projectList = [];
        var folderList = [];
        var folderOpen = this.state.folderOpen;
        reply.forEach(
            (json) => {
                if(json.folder !== null) {
                    if(folderList[json.folder] === undefined) {
                        folderList[json.folder] = projectList.push([]) - 1;
                    }
                    if(folderOpen[json.folder] === undefined) {
                        folderOpen[json.folder] = false;
                    }
                    projectList[folderList[json.folder]].push(json);
                } else {
                    projectList.push(json);
                }
            }
        );
        this.setState({projectList: projectList, folderOpen: folderOpen});
    }

    /* Reload the project list when a project is deleted */
    handleProjectRemoved(reply) { API.GetProject(-1, this.handleProjectsLoaded); }

    /* Select newly created project */
    handleCreatedNew(reply) {
        var projectList = this.state.projectList;
        projectList.unshift(reply);
        this.setState({projectList: projectList, projectName: reply["title"], projectId: reply["id"]});
        this.props.onProjectChanged(reply["id"], reply["title"]);
    }

    /* Get project state icon */
    getProjectState(project) {
        if(project.complete === true) {
            return <span className="material-symbols-outlined sbStateDone">check_circle</span>;
        } else if(project.running === true) {
            return <span className="material-symbols-outlined sbStateRunning">change_circle</span>;
        } else {
            return "";
        }
    }

    renderProject(project, i) {
        return (<div key={"row" + i} className={(project.id === this.state.projectId) ? 'topRow activeProject' : 'topRow'} onClick={() => {
            this.setState({projectName: project.title, projectId: project.id});
            this.props.onProjectChanged(project.id, project.title);
        }}>
            {(this.state.projectId !== 0) ? <div key="state" className="sbState">{ this.getProjectState(project) }</div> : <></>}
            <div title={project.title} key="title" className='sbTitle'>{project.title}</div>
            {(this.state.projectId !== 0) ? <div key="btn" className='sbBtn'>
                <button onClick={() => {
                    this.setState({deleteProject: i, deleteTitle: project.title});
                }} className='sbProjBtn'><span className="material-symbols-outlined">close</span></button>
            </div> : <></> }
        </div>
        );
    }

    render() {
        var projectList = this.state.projectList;
        var folderList = this.state.folderList;
        var folderOpen = this.state.folderOpen;
        return (
            <div className={
                clsx(
                    "sidebar", 
                    (!this.props.open && this.state.projectId !== 0) && "sbClosed", 
                    this.state.expandSidebar && "sbExpand",
                    this.state.projectId === 0 && "fullPage"
            )} key="sidebar">
                {/* Button to create a new project */}
                <NewOpenProject t={this.props.t} onSave={(name) => API.CreateProject(name, this.handleCreatedNew)} key="newProj"/>
                {/*<HelpPopup position={(this.state.projectId === 0) ? "left top" : "right top"} gif={newProjGif} />*/}
                {/* Button to expand the sidebar for longer text */}
                {(this.state.projectId !== 0) ? <button className={(this.state.expandSidebar) ? "sbRotateBtn rotatedBtn" : "sbRotateBtn"} onClick={() => this.setState({expandSidebar: !this.state.expandSidebar})}>
                    <span className="material-symbols-outlined">navigate_next</span>
                </button> : <></>}
                {/* The list of projects */}
                <div key="projectList" className='sbTable'>
                    {projectList.map(
                        (project, i) => {
                            if(Array.isArray(project)) {
                                var folder = project[0].folder;
                                var projs = project.map((p, i) => {return this.renderProject(p, i);});

                                return (
                                <div key={"row" + i} className='folderRow'>
                                    <div 
                                        title={folderList[folder].title} 
                                        key="title" 
                                        className='sbFolderTitle'
                                        onClick={() => {folderOpen[folder] = !folderOpen[folder]; this.setState({folderOpen: folderOpen})}}
                                    >
                                        <div className='sbProjBtn'><span className="material-symbols-outlined">{(folderOpen[folder]) ? "keyboard_arrow_up" : "keyboard_arrow_down"}</span></div>
                                        <div className='sbTitle'>{folderList[folder].title}</div>
                                    </div>
                                    {(folderOpen[folder] === true) ? projs : ""}
                                    </div>);
                            } else {
                                return this.renderProject(project, i);
                            }
                        }
                    )}
                </div>

                <a className='button hugeButton smallerText' href="/Markers.pdf" download="Markers.pdf" target="_blank" rel="noopener noreferrer">{this.props.t("downloadmarkers")}</a>

                {/* Delete confirm popup */}
                <ConfirmPopup 
                    t={this.props.t}
                    open={(this.state.deleteProject >= 0)} 
                    title={this.props.t("delete") + " " + this.state.deleteTitle} 
                    message={this.props.t("suredelete") + " " + this.state.deleteTitle} 
                    onAccept={() => {
                        if(projectList) {
                            var id = projectList[this.state.deleteProject].id;
                            if(id === this.state.projectId){
                                this.setState({projectId: 0, projectName: ""});
                                this.props.onProjectChanged(0, "");
                            } 
                            projectList.splice(this.state.deleteProject, 1);
                            API.RemoveProject(id, this.handleProjectRemoved);
                            this.setState({deleteProject: -1, deleteTitle: ""});
                        }
                    }} 
                    onDecline={() => {
                        this.setState({deleteProject: -1, deleteTitle: ""});
                    }}
                />
            </div>
        );
    }
}